const Config = {
  organizationName: 'Autokwix',
  siteUrl: 'https://autokwix.com',
  logoIcon: 'https://autokwix.com/img/autokwix-logo.svg',
  logoIconPublisher: 'https://autokwix.com/img/autokwix-logo-publisher.png',
  siteDescription: 'Autokwix is your complete guide to tune your car. We review different automotive parts, provide shopping advice and price comparisons.',
  socialLinks: ['https://www.facebook.com/autokwix/'],
  authorName: "Liam",
  startPageUrl: "https://autokwix.com",
  startPageName: "Reviews",
  twitterSite: "@autokwix",
  analyticsConfig: {

    "vars": {
      "gtag_id": process.env.ANALYTICS_ID,
      "config": {
        [process.env.ANALYTICS_ID]: { "groups": "default" }
      }
    },
    "triggers": {
      "trackPageview": {
        "on": "visible",
        "request": "pageview"
      },
      "cardAmazonLinkClick": {
        "on": "click",
        "selector": ".p-card .amazon-link",
        "request": "event",
        "vars": {
          "event_name": "card_amazon_link_click",
          "event_category": "card", // TODO: add _${canonicalPath}
          "event_action": "${productName}_button",
          "method": "Google"
        }
      },
      "trackAnchorClicks": {
        "on": "click",
        "selector": "a",
        "request": "event",
        "vars": {
          "event_name": "card_amazon_link_click",
          "event_category": "links",
          "event_action": "click",
          "event_label": "${canonicalUrl}",
          "method": "Google"
        }
      },
      "cardGalleryNext": {
        "on": "click",
        "request": "event",
        "selector": ".we-rec .amp-carousel-button-next",
        "vars": {
          "event_name": "card_gallery_next",
          "event_category": "card_gallery_change",
          "event_action": "next",
        },
        "extraUrlParams": {
          "ni": 1
        }
      },
      "cardGalleryPrev": {
        "on": "click",
        "request": "event",
        "selector": ".we-rec .amp-carousel-button-prev",
        "vars": {
          "event_name": "card_gallery_prev",
          "event_category": "card_gallery_change",
          "event_action": "prev",
        },
        "extraUrlParams": {
          "ni": 1
        }
      },
      "tableAmazonLinkClick": {
        "on": "click",
        "selector": ".table .amazon-link",
        "request": "event",
        "vars": {
          "event_name": "table_amazon_link_click",
          "event_category": "table",
          "event_action": "${productName}_button",
          "method": "Google"
        }
      },
      "tableProductTitleClick": {
        "on": "click",
        "selector": ".table .table__product-name",
        "request": "event",
        "vars": {
          "event_name": "table_product_title_click",
          "event_category": "table",
          "event_action": "${productName}_title",
          "method": "Google"
        }
      },
      "productReviewAmazonLinkClick": {
        "on": "click",
        "selector": ".product .amazon-link",
        "request": "event",
        "vars": {
          "event_name": "product_review_amazon_link_click",
          "event_category": "product",
          "event_action": "${productName}_button",
          "method": "Google"
        }
      },
      "relatedArticleClick": {
        "on": "click",
        "request": "event",
        "selector": ".i-card",
        "vars": {
          "event_name": "related_article_click",
          "event_category": "related_article",
          "event_action": "${slug}",
          "method": "Google"
        }
      }
    }
  }
};

export default Config;


// WEBPACK FOOTER //
// ./src/config/index.js